import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  id: string;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle,
  id
}: FAQItemProps) {
  const headingId = `faq-heading-${id}`;
  const panelId = `faq-panel-${id}`;
  return <div className="border border-gray-200 rounded-lg overflow-hidden mb-3" data-id="element-19">
      <h3 data-id="element-20">
        <button onClick={onToggle} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" aria-expanded={isOpen} aria-controls={panelId} id={headingId} data-id="element-21">
          <span className="font-bold text-gray-900 text-base md:text-lg pr-4" data-id="element-22">
            {question}
          </span>
          <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-23" />
        </button>
      </h3>
      <div id={panelId} role="region" aria-labelledby={headingId} className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} hidden={!isOpen} data-id="element-24">
        <p className="px-5 pb-5 text-gray-600 leading-relaxed" data-id="element-25">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 md:py-20 px-4" aria-labelledby="faq-title" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <h2 id="faq-title" className="font-heading text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-28">
          ❓ Preguntas frecuentes
        </h2>

        <FAQItem id="1" question="¿Necesito experiencia previa?" answer="No. Está pensado tanto para principiantes como para herreros con experiencia." isOpen={openIndex === 0} onToggle={() => toggle(0)} data-id="element-29" />
        <FAQItem id="2" question="¿Es material digital?" answer="Sí. Acceso inmediato desde cualquier dispositivo." isOpen={openIndex === 1} onToggle={() => toggle(1)} data-id="element-30" />
        <FAQItem id="3" question="¿Puedo usar los planos para vender?" answer="Sí. Están pensados para fabricar y generar ingresos." isOpen={openIndex === 2} onToggle={() => toggle(2)} data-id="element-31" />
        <FAQItem id="4" question="¿Es un curso o planos?" answer="Es un sistema completo con planos + formación práctica." isOpen={openIndex === 3} onToggle={() => toggle(3)} data-id="element-32" />
      </div>
    </section>;
}